import { EventToolbox } from 'client/utils/event-toolbox';
import { PRIVATE_PARTY_EVENTS } from 'site-modules/shared/constants/private-party/private-party-events';
import {
  CREATIVE_ID_ENTRY_PRIVATE_PARTY,
  CREATIVE_ID_DASHBOARD_LISTINGS,
  EDIT_RESUBMIT,
  WHY_NOT_APPROVED,
} from 'site-modules/shared/constants/private-party/private-party';
import { TrackingConstant } from 'client/tracking/constant';
import {
  CREATIVE_ID_CREATE_LISTING_LICENSE_PLATE_ENTRY,
  CREATIVE_ID_CREATE_LISTING_VIN_ENTRY,
  CREATIVE_ID_LISTING_API_POST,
  CREATIVE_ID_NOT_APPROVED_REASONS,
  CREATIVE_ID_SUMMARY_CHECKOUT,
  CREATIVE_ID_API_PHOTOS,
} from 'site-modules/private-listing/constants/tracking';
import { getCreativeId } from 'client/engagement-handlers/helper';

function fireWidgetViewTracking({ detail: { creativeId, actionCause } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_WIDGET_VIEW,
    event_data: {
      action_name: TrackingConstant.ACTION_WIDGET_VIEW,
      action_cause: actionCause || TrackingConstant.ACTION_CAUSE_SCROLL,
      creative_id: creativeId,
      total_page_height: Math.max(document.body.scrollHeight, document.body.offsetHeight),
    },
  });
}

function fireSignUpTracking({ detail: { creativeId } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_START,
    event_data: {
      action_name: TrackingConstant.ACTION_SIGN_UP,
      action_cause: TrackingConstant.PAGE_LOAD_CAUSE,
      action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
      subaction_name: TrackingConstant.BEGIN_SIGN_UP,
      creative_id: creativeId,
    },
  });
}

function fireLicensePlateInputTracking({ detail: { isValidLicensePlate } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: isValidLicensePlate
        ? TrackingConstant.LICENSE_PLATE_INPUT_SUCCESS
        : TrackingConstant.LICENSE_PLATE_INPUT_FAILURE,
      creative_id: CREATIVE_ID_CREATE_LISTING_LICENSE_PLATE_ENTRY,
    },
  });
}

function fireLicensePlateStateTracking() {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.LICENSE_PLATE_STATE_SUCCESS,
      creative_id: CREATIVE_ID_CREATE_LISTING_LICENSE_PLATE_ENTRY,
    },
  });
}

function fireVinInputTracking({ detail: { isValidVin } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: isValidVin ? TrackingConstant.VIN_INPUT_SUCCESS : TrackingConstant.VIN_INPUT_FAILURE,
      creative_id: CREATIVE_ID_CREATE_LISTING_VIN_ENTRY,
    },
  });
}

function fireListingStyleSelectTracking({ detail: { creativeId } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.VEHICLE_STYLE_INPUT_SUCCESS,
      creative_id: creativeId,
    },
  });
}

function fireStyleDecodeOutcomeTracking({ detail: { value } }) {
  let matchValue = 0;
  if (value === 1) {
    matchValue = 1;
  } else if (value > 1) {
    matchValue = 2;
  }
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.SUBACTION_STYLE_DECODE,
      creative_id: CREATIVE_ID_CREATE_LISTING_VIN_ENTRY,
      value: matchValue,
    },
  });
}

function fireSubmitVehicleDetailsTracking({ detail: { vehicleDetails, creativeId } }) {
  Object.keys(vehicleDetails).map(key =>
    EventToolbox.fireTrackAction({
      event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
      event_data: {
        action_name: TrackingConstant.ACTION_FILL_FORM,
        action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
        action_category: TrackingConstant.USER_ACTION_CATEGORY,
        subaction_name: key,
        creative_id: creativeId,
        value: vehicleDetails[key],
      },
    })
  );
}

function fireSelectPhotosTracking({ detail: { creativeId, value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      subaction_name: TrackingConstant.SUBACTION_SELECT_PHOTOS,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      creative_id: creativeId,
      value,
    },
  });
}

function fireRemovePhotoTracking({ detail: { creativeId } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      subaction_name: TrackingConstant.SUBACTION_REMOVE_PHOTO,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      creative_id: creativeId,
    },
  });
}

function firePhotoUploadSystemErrorTracking({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.SYSTEM_ACTION_CAUSE,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.SUBACTION_PHOTO_UPLOAD_SYSTEM_ERROR,
      creative_id: CREATIVE_ID_API_PHOTOS,
      value,
    },
  });
}

function fireContinueTracking({ detail: { creativeId, subactionName, value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: subactionName,
      creative_id: creativeId,
      value,
    },
  });
}

function firePriceInputTracking({ detail: { status, creativeId } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: `${TrackingConstant.PRICE_INPUT}_${status}`,
      creative_id: creativeId,
    },
  });
}

function fireSubmitListingTracking({ detail: { element, status, value } }) {
  const creativeId = getCreativeId(element);
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_END,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: `${TrackingConstant.SUBMIT_LISTING_FOR_APPROVAL}_${status}`,
      creative_id: creativeId,
      value,
    },
  });
}

function fireSellerInfoInputTracking({ detail: { creativeId, isValid, name, actionCause } }) {
  const formatName = name?.replaceAll(/[A-Z](?=[a-z]*|$)|([A-Z])/g, match => `_${match}`)?.toLowerCase();
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: actionCause || TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: `${formatName}_input_${isValid ? 'success' : 'failure'}`,
      creative_id: creativeId,
    },
  });
}

function fireAPISystemErrorTracking({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_PROGRESS,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.API_SYSTEM_ERROR,
      creative_id: CREATIVE_ID_LISTING_API_POST,
      value,
    },
  });
}

function fireShareContentTracking({ detail: { creativeId, value, subactionName } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.ACTION_SHARE_CONTENT,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: subactionName,
      creative_id: creativeId,
      value,
    },
  });
}

function fireSummaryCheckoutTracking({ detail: { creativeId, value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_START,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.CHECKOUT_DEEPLINK_STARTED,
      creative_id: creativeId,
      value,
    },
  });
}

function fireCreateDealTracking({ detail: { status, value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_END,
    event_data: {
      action_name: TrackingConstant.ACTION_FILL_FORM,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
      subaction_name: TrackingConstant.CHECKOUT_DEEPLINK_COMPLETED,
      creative_id: `${CREATIVE_ID_SUMMARY_CHECKOUT}-${status}`,
      value,
    },
  });
}

function fireManageListingTracking({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type:
      value === EDIT_RESUBMIT ? TrackingConstant.EVENT_TYPE_ACTION_START : TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.ACTION_VIEW_CONTENT,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.MANAGE_PRIVATE_PARTY_LISTING,
      creative_id: CREATIVE_ID_DASHBOARD_LISTINGS,
      value,
    },
  });
}

function fireNotApprovedListingReasonsTracking() {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.ACTION_VIEW_CONTENT,
      action_cause: TrackingConstant.ACTION_CAUSE_LINK_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.VIEW_NOT_APPROVED_REASONS,
      creative_id: CREATIVE_ID_DASHBOARD_LISTINGS,
      value: WHY_NOT_APPROVED,
    },
  });
}

function fireNotApprovedBtnTracking() {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_START,
    event_data: {
      action_name: TrackingConstant.ACTION_VIEW_CONTENT,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.MANAGE_PRIVATE_PARTY_LISTING,
      creative_id: CREATIVE_ID_NOT_APPROVED_REASONS,
      value: EDIT_RESUBMIT,
    },
  });
}

function fireStartPrivatePartyListingTracking({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_START,
    event_data: {
      action_name: TrackingConstant.ACTION_TOOL_SELECT,
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.START_PRIVATE_PARTY_LISTING,
      creative_id: CREATIVE_ID_ENTRY_PRIVATE_PARTY,
      value,
    },
  });
}

function fireCaramelWebsiteClickoutTracking({ detail: { value } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.ACTION_WEBSITE_CLICKOUT,
      action_cause: TrackingConstant.ACTION_CAUSE_LINK_CLICK,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.LEARN_HOW_CARAMEL_WORKS,
      creative_id: CREATIVE_ID_ENTRY_PRIVATE_PARTY,
      value,
    },
  });
}

export const PrivatePartyEngagementHandler = {
  init: () => {
    EventToolbox.on(PRIVATE_PARTY_EVENTS.WIDGET_VIEW, fireWidgetViewTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SIGN_UP, fireSignUpTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.ENTER_PLATE_INPUT, fireLicensePlateInputTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SELECT_STATE_INPUT, fireLicensePlateStateTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.VIN_INPUT, fireVinInputTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.LISTING_STYLE_SELECT, fireListingStyleSelectTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.STYLE_DECODE, fireStyleDecodeOutcomeTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SUBMIT_VEHICLE_DETAILS, fireSubmitVehicleDetailsTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SELECT_PHOTOS, fireSelectPhotosTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.REMOVE_PHOTO, fireRemovePhotoTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.CONTINUE, fireContinueTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.PHOTO_UPLOAD_SYSTEM_ERROR, firePhotoUploadSystemErrorTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.PRICE_INPUT, firePriceInputTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SUBMIT_LISTING, fireSubmitListingTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.MANAGE_LISTING, fireManageListingTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.NOT_APPROVED_REASONS, fireNotApprovedListingReasonsTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SELLER_INFO_INPUT, fireSellerInfoInputTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.API_SYSTEM_ERROR, fireAPISystemErrorTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.NOT_APPROVED_BUTTON, fireNotApprovedBtnTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SHARE_CONTENT, fireShareContentTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.SUMMARY_CHECKOUT, fireSummaryCheckoutTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.CREATE_DEAL, fireCreateDealTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.START_PP_LISTING, fireStartPrivatePartyListingTracking);
    EventToolbox.on(PRIVATE_PARTY_EVENTS.CARAMEL_WEBSITE_CLICKOUT, fireCaramelWebsiteClickoutTracking);
  },
};
